// extracted by mini-css-extract-plugin
export default {"row":"Customers_row__SouQX","col":"Customers_col__P4gnd","card":"Customers_card__-+PQ6"};